import axios from 'axios'
import router from '../router/index'
import store from '../store/index'
import qs from 'qs'
import { Toast, Dialog } from 'vant';
// 请求
const api = axios.create({
    baseURL: "/",
    timeout: 10000
})
// api.defaults.baseURL = (window.location.href.indexOf('192.168') != -1 || window.location.href.indexOf('.test.') != -1) ? 'http://service.test.wormhoo.com' : 'https://service.wormhoo.com';
// 请求拦截
api.interceptors.request.use((config) => {
    if(config.loading){
        Toast.loading({
            message: '加载中...',
            forbidClick: true,
          });
    }
    if(config.api2) return config
    let token = localStorage.getItem('token') || ''
    if(!config.host) config.headers.Authorization = 'Bearer ' + token
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    let qsList = ['/api/goods/test/answer','/api/auth/sms','/api/order/make','/api/order/make/again','/api/xu/wechat/code','/api/users/flatform/record','/api/flat/test/answer','/api/users/flat/record','/api/flat/record/list','/api/auth/cert/sms','/api/flat/cert/list','/api/flatform/record/list']
    if(config.data) {
    } else {
        config.data = {
        }
    }
    if(config.host) {
        config.url = config.host + config.url
    }
    // config.data.token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC9zZXJ2aWNlLndvcm1ob28uY29tXC9cL2FwaVwvYXV0aFwvbG9naW4iLCJpYXQiOjE2NTAyNjAyMDgsImV4cCI6MTY2MDYyODIwOCwibmJmIjoxNjUwMjYwMjA4LCJqdGkiOiJXc3R4MXJETHJKREdRQXhMIiwic3ViIjo1MDIzNywicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.O2efMrDNR4Dr0zTDdfA2b2n2GTGo6-tfw_nBYcIqjXg';
    if (config.method == 'get' ) {
        
        let params = [];
        for (const key in config.data) {
            if (Object.hasOwnProperty.call(config.data, key)) {
                const element = config.data[key];
                params.push(key + '=' + element)
            }
        }
        params = '?' + params.join('&');
        config.url += params;
    }else if(qsList.includes(config.url) && !config.api2){
        config.data = qs.stringify(config.data)
    }
    return config
}, err => {
    console.log(err);
})

//在 main.js 设置全局的请求次数，请求的间隙
api.defaults.retry = 4;
api.defaults.retryDelay = 1000;

api.interceptors.response.use(res => {
    Toast.clear();
    // 对响应码的处理
    if (res.status == 200) {
        console.log(window.location)
       
        if((res.data.code == 1002 || res.data.msg == 'Token not provided') && window.location.hash.indexOf('setting') != -1 ) {
            localStorage.clear();
            store.commit('SET_LOGINSTATUS', false)
            store.commit('SET_USER', null)
            store.commit('setToken', null)
            store.commit('SET_STUDY', null)
            Dialog.confirm({
                message:'登录已过期，请重新登录',
                confirmButtonText: '立即登录',
                cancelButtonText: '回到首页',
              }).then(() => {
                router.push(`/${router.app.$route.params.plat_type}/login/phone`);
              }).catch(() => {
                router.push(`/${router.app.$route.params.plat_type}/index`);         
              });
        } else {
            return res.data
        }
    }
}, error => {
    Toast.clear();
        console.log(error)
        console.log(error.code!=='ECONNABORTED' || error.message.indexOf('timeout') == -1)
        if(error.code!=='ECONNABORTED' && error.message.indexOf('timeout') == -1 && error.code != 'ERR_NETWORK') {
             return{
                code:error.response.status,
                msg:error.response.status!==404 ? '系统错误，请稍后再试' : '接口不存在404'
             }
        }
    let config = error.config;
   
    // If config does not exist or the retry option is not set, reject
    if(!config || !config.retry) return err;

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if(config.__retryCount >= config.retry) {
        // Reject with the error
        // console.log('请求失败', error, error.code=='ECONNABORTED', error.message.indexOf('timeout') != -1);
        if(error.code=='ECONNABORTED' && error.message.indexOf('timeout') != -1) {
            return {
                code: 'timeout',
                msg: '网络连接超时'
            }
        }
        if(error.code == 'ERR_NETWORK') {
            return {
                code: 'network',
                msg: '网络连接超时'
            }
        }
        
        return error;
    }
    // Increase the retry count
    config.__retryCount += 1;
    
    // Create new promise to handle exponential backoff
    var backoff = new Promise(function(resolve) {
        setTimeout(function() {
            resolve();
        }, config.retryDelay || 1);
    });
    
    // Return the promise in which recalls axios to retry the request
    return backoff.then(function() {
        // console.log('4444')
        config.api2 = true
        return api(config);
    });
})

export default api
